// virtual module provided by iconGroupPlugin in vite.config.js
// eslint-disable-next-line import-x/no-unresolved
import groupLoaders from "virtual:icon-groups";

import PlaceholderIcon from "@/icons/system/placeholder.svg?component";

const groupCache = new Map();

function loadGroup(groupName) {
  let group = groupCache.get(groupName);
  if (!group) {
    group =
      groupLoaders[groupName]?.() ?? Promise.reject(new Error(`Unknown icon group: ${groupName}`));
    group.catch(() => groupCache.delete(groupName));
    groupCache.set(groupName, group);
  }
  return group;
}

export async function loadIcon(fullName) {
  const pos = fullName.indexOf("/");
  const group = fullName.slice(0, pos);
  const name = fullName.slice(pos + 1);
  try {
    const icons = await loadGroup(group);
    return icons[name] ?? PlaceholderIcon;
  } catch {
    return PlaceholderIcon;
  }
}
